import React from "react";
import withStyles from "react-jss";
import Price from "../components/Price";

const styles = (theme) => ({
	avans: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: 1,
		letterSpacing: "2px",
		color: theme.palette.colors.oneMoreGrey,
		textTransform: "uppercase",
		marginTop: "25px",
	},
	avansText: {},
	avansValue: {},
	[`@media (max-width: ${theme.media.sm})`]: {
		avans: {
			marginTop: 0,
			marginBottom: "25px",
		},
	},
});

const Component = ({ classes, value, avansText, avansValue, after = false, text }) => {
	return (
		<React.Fragment>
			<Price
				text={text}
				value={value}
				measureText={after ? text.SUBSCRIPTION_FEE_TITLE_ : text.SUBSCRIPTION_FEE_TITLE}
				green={after}
			/>
			<div className={classes.avans}>
				<div className={classes.avansText}>{avansText}</div>
				<div className={classes.avansValue}>{avansValue}</div>
			</div>
		</React.Fragment>
	);
};

const PriceWithAvansLayout = withStyles(styles)(Component);
PriceWithAvansLayout.displayName = "PriceWithAvansLayout";

export default PriceWithAvansLayout;
